import React, { Fragment, useState, useEffect } from "react";
import { GetData, ShowData, checkEmpty } from "./Components/services";
import Loading from "../../Common/Loading";
import SplitData from "../../Common/SplitData";
import { Helmet } from "react-helmet";

function Index() {
  const initialState = {
    loading: true,
    data: null,
  };
  const [state, setstate] = useState(initialState);
  const Handler = () => {
    setstate({ ...state, loading: true });
    GetData().then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    Handler();
    scrollToTop();
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | حریم خصوصی </title>
        <meta name="description" content={"حریم خصوصی"} />
      </Helmet>

      <div className="container my-5">
        <div className="row justify-content-lg-center" id={"#rules"}>
          <div className={`col-lg-9 col-sm-12 `}>
            {state.loading ? (
              <Loading count={1} col={12} height={300} />
            ) : (
              <Fragment>
                {checkEmpty ? (
                  <div>
                    <h3 className="rules-topict mb-4">توضیحات حریم خصوصی</h3>
                    <p>
                      <SplitData data={ShowData(state.data, "Privacy")} />
                    </p>
                  </div>
                ) : (
                  <p>اطلاعات موجود نیست</p>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Index;
